import React, { useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import XCircleblack from "../../IconComponents/XCircleblack";
import {
  postDataWithBody,
  getData,
  putDataWithBody,
} from "../../../Services/Services";
import { createConfig, updateConfig } from "../../../Services/EndPoints";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation} from "react-i18next";
import { ThemeContext } from "../../..";

const ModalResourceType = (props) => {
  const {
    title,
    titleValue,
    show,
    handleToggle,
    size,
    popupLabel,
    buttonLabel,
    data,
    configurationButton
  } = props;
  console.log("update value=", data);
  const { theme } = useContext(ThemeContext);
  
  // Initialize inputValue properly
  const getInitialValue = () => {
    if (!data) return "";
    if (typeof data === "string") return data;
    if (typeof data === "object" && data.value) return data.value;
    return "";
  };
  
  const [inputValue, setInputValue] = useState(getInitialValue());
  const { t } = useTranslation();
  
  async function saveConfigData() {
    // Only validate if configurationButton is true
    if (configurationButton && (!inputValue || inputValue.trim() === "")) {
      toast.error("Please enter a value", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }
    
    var res = null;
    const configVal = inputValue.trim(); // Get the value from the state and trim whitespace
    
    if (data) {
      // For update case, handle both string and object data
      const updateData = typeof data === "object" ? { ...data } : { value: data };
      updateData.value = configVal;
      
      res = await putDataWithBody(updateConfig, updateData, {});
      if (res.status == "success") {
        props.showSuccessMsg(props.selectedConfigId);
        if (props.onAddJobTitle) props.onAddJobTitle(configVal);
        handleToggle();
      } else {
        toast.error(res.msg, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      }
    } else {
      console.log("configVal", configVal);
      let dataElem = {
        categoryName: props.selectedConfigId,
        code: props.selectedConfigId,
        value: configVal,
        status: true,
      };

      if (props.onAddJobTitle){
        props.onAddJobTitle(configVal);
        handleToggle();
      } else {
        res = await postDataWithBody(createConfig, dataElem, {});
        if(res.status == "success"){
          props.showSuccessMsg(props.selectedConfigId);
          handleToggle();
        }
        else{
          toast.error(res.msg, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
        }
      }
    }
  }
  
  // Update the inputValue state when the input field changes
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  
  return (
    <>
      <Modal
        show={show}
        onHide={handleToggle}
        id={theme}
        size={size}
        className="table__modal__popup"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {t(title)}
            {t(titleValue)}
          </Modal.Title>
          <XCircleblack
            className="cursor-pointer"
            onClick={handleToggle}
            width="1.5em"
            height="1.5em"
          />
        </Modal.Header>
        <Modal.Body>
          <div className="create__resource--popup">
            <div className="form-group">
              <label
                className="create__resource--label"
                htmlFor="tfld_config_value"
              >
                {popupLabel}{configurationButton && <span style={{ color: 'red' }}>*</span>}
              </label>
              <input
                type="text"
                maxLength={40}
                className="form-control"
                id="tfld_config_value"
                value={inputValue}
                onChange={handleInputChange}
                required={configurationButton}
                placeholder="Enter value..."
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={saveConfigData}
            type="button"
            className="btn btn-success"
            style={{ backgroundColor: "#40B2B7" }}
          >
            {t(buttonLabel)}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalResourceType;